import React, { createContext, useState, useEffect } from 'react';
import CryptoJS from 'crypto-js';

export const AuthContext = createContext();

const HASH_SECRET = '9e107d9d372bb6826bd81d3542a419d6'; 

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    email: localStorage.getItem('hashedEmail') ? CryptoJS.AES.decrypt(localStorage.getItem('hashedEmail'), HASH_SECRET).toString(CryptoJS.enc.Utf8) : null,
  });

  useEffect(() => {
    if (auth.email) {
      const hashedEmail = CryptoJS.AES.encrypt(auth.email, HASH_SECRET).toString();
      localStorage.setItem('hashedEmail', hashedEmail);
    } else {
      localStorage.removeItem('hashedEmail');
    }
  }, [auth]);

  const login = (email) => {
    setAuth({ email });
  };

  const logout = () => {
    setAuth({ email: null });
  };

  return (
    <AuthContext.Provider value={{ auth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
